import React from 'react';
import { LiveSessionVM } from './useLiveSession';

/**
 * One calm line replacing the busy metric-tiles row: "N here · N still to
 * arrive · N announced absent", with the off-schedule note (Task 9b)
 * appended when present.
 */
const SessionSummaryLine: React.FC<{
  counts: LiveSessionVM['counts'];
  offSchedule?: LiveSessionVM['offSchedule'];
}> = ({ counts, offSchedule }) => {
  return (
    <p data-testid="session-summary-line" className="text-sm text-slate-600">
      <b className="text-slate-900">{counts.here}</b> here ·{' '}
      <b className="text-slate-900">{counts.expected}</b> still to arrive ·{' '}
      <b className="text-slate-900">{counts.announcedAbsent}</b> announced absent
      {offSchedule && <span className="text-slate-500"> · {offSchedule.copy}</span>}
    </p>
  );
};

export default SessionSummaryLine;
